import { useTranslation } from "react-i18next";
import { SceneOff as SceneOffType } from "@ltypes/scene";
import TextField from "@components/forms/TextField/TextField";

type SceneOffProps = {
    scene: SceneOffType,
    onChange: (field: string, value: string|number|boolean) => void,
};

function SceneOff(props: SceneOffProps) {

    const { t } = useTranslation();

    return (
        <div className="row g-3">
            <div className="col-12 col-md-6">
                <div className="row g-3">
                    <div className="col-12">
                        <TextField label={t('page.scenes.data.display_duration')} value={props.scene.display_duration} onChange={(value: string) => props.onChange('display_duration', value)}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SceneOff;
